import { useState, useEffect, RefObject, useCallback } from 'react';

const useHasScrollbar = (ref: RefObject<HTMLElement | null>) => {
  const [hasVerticalScrollbar, setHasVerticalScrollbar] = useState(false);
  const [hasHorizontalScrollbar, setHasHorizontalScrollbar] = useState(false);

  const checkScrollbars = useCallback(() => {
    const container = ref.current;
    if (!container) return;

    const vertical = container.scrollHeight > container.clientHeight;
    const horizontal = container.scrollWidth > container.clientWidth;

    setHasVerticalScrollbar((prev) => (prev !== vertical ? vertical : prev));
    setHasHorizontalScrollbar((prev) => (prev !== horizontal ? horizontal : prev));
  }, [ref]);

  useEffect(() => {
    checkScrollbars();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', checkScrollbars);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', checkScrollbars);
      }
    };
  }, [checkScrollbars]);

  return { hasVerticalScrollbar, hasHorizontalScrollbar };
};

export default useHasScrollbar;
